import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import DropdownIndicator from './select-dropdown-indicator';
import ReactTooltip from 'react-tooltip';

export const SelectInput = ({
  name,
  label,
  onChange,
  defaultOption,
  value,
  options,
  placeholder = 'Select...',
  error = '',
  isShallowGroup = false,
  helpText,
}) => {
  if (defaultOption) {
    options.unshift({value: '', label: defaultOption});
  }

  return (
    <div className={`form-group${isShallowGroup ? ' shallow' : ''}${error.length ? ' has-error' : ''}`}>
      <div className="control-block">
        <label id={`${name}-label`} htmlFor={`${name}-select`}>
          {label}
          {helpText &&
            <i className="togo-icon togo-icon-question-circle togo-icon-question-circle-leftpadding help-icon-move-down" data-tip data-for={`${name}_tip`} />}
          {helpText &&
            <ReactTooltip
              id={`${name}_tip`}
              className="helpToolTip"
              type="light"
              place="bottom"
              effect="solid"
              border
              multiline>
              <span>{helpText}</span>
            </ReactTooltip>}
        </label>
        <Select
          id={`${name}-select`}
          name={name}
          value={options.find(option => option.value === value) || null}
          onChange={onChange}
          options={options}
          placeholder={placeholder}
          isSearchable
          clearable={false}
          className="form-control select"
          classNamePrefix="react-select"
          components={{ DropdownIndicator }}
          {...{'aria-labelledby': `${name}-select`}}
        />
        {error &&
          <p id={`${name}-select-error`} className="help-block">{error}</p>}
      </div>

    </div>
  );
};

SelectInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  helpText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  defaultOption: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.object),
  isShallowGroup: PropTypes.bool,
};

export default SelectInput;
